import { useState } from "react";
import { api } from "../lib/api";
import { getGuestId } from "../lib/guest";
import { CheckCircle2, Star, HelpCircle } from "lucide-react";

const OPTIONS = [
  { key: "attending", label: "Attending", icon: CheckCircle2, color: "text-calm", bg: "bg-calm text-white border-calm" },
  { key: "interested", label: "Interested", icon: Star, color: "text-clinical", bg: "bg-clinical text-white border-clinical" },
  { key: "tentative", label: "Tentative", icon: HelpCircle, color: "text-alert", bg: "bg-alert text-white border-alert" },
];

function mineKey() { return "rc_rsvp"; }
function getMine(id) {
  try { return (JSON.parse(localStorage.getItem(mineKey()) || "{}"))[id] || null; } catch { return null; }
}
function setMine(id, status) {
  let m = {};
  try { m = JSON.parse(localStorage.getItem(mineKey()) || "{}"); } catch (e) { console.debug("RSVP read failed:", e); }
  if (status) m[id] = status; else delete m[id];
  localStorage.setItem(mineKey(), JSON.stringify(m));
}

export function TrainingRsvp({ trainingId, counts, testid = "rsvp", endpoint }) {
  const [mine, setMineState] = useState(() => getMine(trainingId));
  const [c, setC] = useState(counts || { attending: 0, interested: 0, tentative: 0 });
  const url = endpoint || `/training/${trainingId}/rsvp`;

  const choose = async (status) => {
    const next = mine === status ? "none" : status;
    try {
      const { data } = await api.post(url, { guest_id: getGuestId(), status: next });
      setC(data.rsvp);
      const applied = next === "none" ? null : next;
      setMine(trainingId, applied);
      setMineState(applied);
    } catch (error) { console.error("RSVP update failed:", error); }
  };

  return (
    <div className="mt-3" data-testid={testid}>
      <p className="text-xs uppercase tracking-wider font-bold text-muted2 mb-1.5">Will you attend?</p>
      <div className="flex flex-wrap gap-2">
        {OPTIONS.map((o) => {
          const active = mine === o.key;
          return (
            <button
              key={o.key}
              type="button"
              data-testid={`${testid}-${o.key}`}
              onClick={() => choose(o.key)}
              className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-full border px-3 py-1.5 transition-colors ${active ? o.bg : `bg-white border-line ${o.color} hover:bg-line/40`}`}
            >
              <o.icon className="w-3.5 h-3.5" /> {o.label}
              <span className={`ml-0.5 tabular-nums ${active ? "text-white/90" : "text-muted2"}`}>{c[o.key] || 0}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
